import { setAccessToken } from './token';

let logoutAction: (() => void) | null = null;

export const setGlobalLogoutAction = (logoutFn: () => void) => {
  logoutAction = logoutFn;
};

export const fallbackLogout = () => {
  console.warn('No logout action set, using default logout.');
  sessionStorage.setItem('isLoggedOut', 'true');
  setAccessToken(null);

  window.location.href = '/login';
};

export const performLogout = () => {
  if (logoutAction) {
    logoutAction();
  } else {
    fallbackLogout();
  }
};
